import FormEvents from '../../utilities/FormEvents'
import ListFormControl from '../../sections/ListForm/ListFormControl'
import { Keys } from './constants'
import {
    StoragePage,
    FormInformation,
    FormNorms,
    TableFormCompany,
    TableFormPermit,
    TableFormTax,
    TableProductData,
    TableFormFiscalCode
} from './types'
import { generateDescription, generateProductCode } from './utilities/generate'
import applyTypeDetailsToForm from './utilities/applyTypeDetailsToForm'
import { dataMemory } from '../../utilities/dataTools'

export const storagePage: StoragePage = {
    product: null,
    step2Done: false,
    mode: 'creation',
    products: dataMemory()
}

/**
 * Step 1
 */

export const formInformation = new FormEvents<FormInformation>(Keys.STEP1, {
    name: '',
    manufacturer_code: '',
    rank: '',
    model: '',
    quantity: '',
    brand: null,
    product_files: [],
    type_product: null,
    type_communications: [],
    hazardous: false,
    precursor: false,
    description_generate: '',
    category: null,
    subcategory: null,
    code: '',
    measurement_range: '',
    country_availability: [],
    impact_ecosystem: [],
    productive_process: [],
    vertical_market: [],
    fiscal_code_ni: '',
    fiscal_code_cr: '',
    fiscal_code_pa: '',
    fiscal_code_ve: '',
    photo: '',
    literature: [],
    services: [],
    certification: [],
    composition: '',
    useful_life: null,
    certificate: false,
    packaging: null,
    presentation_quantity: '',
    presentation_unit: null,
    air_transport: false,
    maritime_transport: false,
    refrigeration: false,
    regulation: null
})

formInformation.store.on('type_product', function (option) {
    if (option && option.value === '2') {
        formInformation.setProps('type_communications', { disabled: false })
    } else {
        formInformation.setProps(
            'type_communications',
            { disabled: true },
            false
        )
        formInformation.setValue('type_communications', [])
    }
    if (option) {
        formInformation.setProps('category', { disabled: false }, false)
    } else {
        formInformation.setProps('category', { disabled: true }, false)
    }
    if (storagePage.mode !== 'edition') {
        formInformation.setValue('category', null)
        formInformation.setValue('subcategory', null)
    }
    if (storagePage.mode === 'edition' && option?.value != null) {
        const typeIndex = parseInt(String(option.value), 10)
        if (!Number.isNaN(typeIndex)) {
            applyTypeDetailsToForm(typeIndex)
        }
    }
})

formInformation.store.on('brand', function (option) {
    generateDescription('brand', option)
    generateProductCode('brand', option)
})

formInformation.store.on('name', function (value) {
    generateDescription('name', value)
})

formInformation.store.on('model', function (value) {
    generateDescription('model', value)
})

formInformation.store.on('rank', function (value) {
    generateDescription('rank', value)
})

formInformation.store.on('quantity', function (value) {
    generateDescription('quantity', value)
})

formInformation.store.on('country_availability', function (options) {
    const countryIds = (options || [])
        .map(c => parseInt(String(c.value), 10))
        .filter(n => !Number.isNaN(n))

    const requiresNi = countryIds.includes(1)
    const requiresCr = countryIds.includes(2)
    const requiresPa = countryIds.includes(3)
    const requiresVe = countryIds.includes(4)

    // Forzar re-render de los inputs de códigos fiscales al cambiar la selección.
    formInformation.setProps('fiscal_code_ni', { disabled: !requiresNi })
    formInformation.setProps('fiscal_code_cr', { disabled: !requiresCr })
    formInformation.setProps('fiscal_code_pa', { disabled: !requiresPa })
    formInformation.setProps('fiscal_code_ve', { disabled: !requiresVe })
})

formInformation.setProps('category', { disabled: true })
formInformation.setProps('subcategory', { disabled: true })

formInformation.store.on('category', function (option) {
    if (option) {
        formInformation.setProps('subcategory', { disabled: false }, false)
        formInformation.setParams('subcategory', {
            category_id: option.value
        })
    } else {
        formInformation.setProps('subcategory', { disabled: true }, false)
    }
    formInformation.setValue('subcategory', null)
})

formInformation.store.on('subcategory', function () {
    // No action needed
})

formInformation.store.on('manufacturer_code', function (value) {
    generateProductCode('manufacturer_code', value)
})

/**
 * Step 2
 */

export const formNorms = new FormEvents<FormNorms>(Keys.STEP2, {
    lifetime: '',
    refrigeration: false,
    max_temperature: '',
    min_temperature: '',
    air_transport: false,
    marine_transport: false,
    ground_transport: true,
    storable_products: []
})

formNorms.store.on('refrigeration', function (checked) {
    formNorms.setProps('min_temperature', { disabled: !checked })
    formNorms.setProps('max_temperature', { disabled: !checked })
    if (!checked) {
        formNorms.setValue('min_temperature', '')
        formNorms.setValue('max_temperature', '')
    }
})

export const tableProductsControl = new ListFormControl<TableProductData>(
    Keys.TABLE_PRODUCTS,
    ['#', 'Producto', 'Categoría', 'Subcategoría', 'Acciones']
)

/**
 * Step 3
 */

export const tableCompaniesControl = new ListFormControl<TableFormCompany>(
    Keys.COMPANIES,
    ['País', 'Compañia', 'Compra', 'Venta']
)

export const tableFiscalCodeControl = new ListFormControl<TableFormFiscalCode>(
    Keys.FISCAL_CODE,
    ['País', 'Compañía', 'Código fiscal de producto']
)

export const tableTaxesControl = new ListFormControl<TableFormTax>(Keys.TAXES, [
    'País',
    'IVA'
])

export const tablePermitsControl = new ListFormControl<TableFormPermit>(
    Keys.PERMITS,
    ['País', 'Importación', 'Exportación', 'Otros']
)
